module.exports = __webpack_public_path__ + "product-compound-capsule-main-thumb-01.jpg?76b36a1e2fe786f075604cd630cf46b6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-main-thumb-01.jpg
// module id = 95
// module chunks = 0